import BookShow from "components/shared/book/show";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { tableContainer } from "helpers/redux";
import { ymEvent } from "helpers/system";
import React from "react";
import { delItem, restoreItem } from "sources/catalogs";

class SystemCatalogsShow extends BookShow {
    state = {
        isLoading: true,
        isValid: true,
        openedDropd: false,
        shouldUpdate: false,
        data: {},
        initial: {},
        showDeleted: false,
        tableColumns: this.tableColumns,
    };

    get tableColumns() {
        return [
            {
                Header: "#",
                id: "row",
                accessor: (d) => d.index,
                Cell: ({ row }) => row.index + 1,
                width: 50,
                sortable: false,
                notExportable: true,
            },
            { Header: "ID", accessor: "id", width: 100, sortable: false },
            { Header: "Название", accessor: "displayName", sortable: false },
            {
                Header: "Удалено",
                accessor: "isDeleted",
                sortable: false,
                filterable: true,
                filterType: "boolean",
                Filter: () => {
                    const options = [
                        { label: "Показать все", value: "null" },
                        { label: "Удаленные", value: "true" },
                        { label: "Не удаленные", value: "false" },
                    ];
                    return (
                        <select
                            className="r-item__filter-select r-item__filter-select--wide field-wrap__input"
                            onChange={(e) =>
                                this.setState({
                                    showDeleted: e.target.value === "null" ? null : e.target.value === "true",
                                })
                            }
                            value={this.state.showDeleted}
                        >
                            {options.map(({ value, label }) => (
                                <option key={value} value={value}>
                                    {label}
                                </option>
                            ))}
                        </select>
                    );
                },
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
            },
            {
                Header: "Действие",
                notExportable: true,
                width: 200,
                id: "action",
                sortable: false,
                Cell: ({ row }) => this.itemActions(row.original),
            },
        ];
    }

    componentDidMount() {
        this.setState({ isLoading: false });
        if (this.catalog()?.propertyName === "ExpenseType") {
            ymEvent("CostItemsDirectoryOpened");
        }
    }

    close = () => {
        const { history } = this.props;
        history.push(paths.systemCatalogs);
    };

    renderCounter = () => null;

    itemActions = (item) => {
        const restoreAction = () => {
            this.props.modal({
                name: "confirm",
                title: "Восстановление элемента",
                text: "Вы уверены, что хотите восстановить элемент?",
                action: () => restoreItem({ id: item.id }),
                buttons: { confirm: "Да", cancel: "Нет" },
                onSuccessAction: () => this.props.mergeParams({}),
            });
        };
        if (item.isDeleted) {
            return (
                <div className="btn btn-xs btn-brand" onClick={restoreAction}>
                    Восстановить
                </div>
            );
        }
        const deleteAction = () => {
            this.props.modal({
                name: "confirm",
                title: "Удаление элемента",
                text: "Вы уверены, что хотите удалить элемент?",
                action: () => delItem({ id: item.id, isDeleted: true }),
                buttons: { confirm: "Да", cancel: "Нет" },
                onSuccessAction: () => this.props.mergeParams({}),
            });
        };
        const editAction = () => {
            this.props.modal({
                name: "organizationCatalogItemForm",
                title: "Редактирование элемента",
                data: { ...item, catalogId: this.props.match.params.id },
                dictionary: this.props.items.find((item) => item.id === Number(this.props.match.params.id)),
                callback: () => this.props.mergeParams({}),
            });
        };
        return (
            <>
                <div className="btn btn-xs btn-secondary mr-2" onClick={editAction}>
                    Изменить
                </div>
                <div className="btn btn-xs btn-outline-danger" onClick={deleteAction}>
                    Удалить
                </div>
            </>
        );
    };

    catalog = () => this.props.items.find((catalog) => catalog.id === Number(this.props.match.params.id));

    catalogItems = () => {
        const items = this.catalog()?.items || [];
        if (this.state.showDeleted === null) {
            return items;
        }
        return items.filter((item) => item.isDeleted === this.state.showDeleted);
    };

    renderHead = () => {
        return (
            <div className="book-show__head align-items-center">
                <div className="book-show__close close close--sm" onClick={this.props.back} />
                <div className="book-show__title">{this.catalog()?.displayName || "Элементы справочника"}</div>
                {this.renderCreateButton()}
            </div>
        );
    };

    renderCreateButton = () => {
        if (!this.props.match.params.id) {
            return null;
        }
        const { modal, mergeParams } = this.props;
        const action = () => {
            if (this.catalog()?.propertyName === "ExpenseType") {
                ymEvent("AddCostItemsDirectoryItemClicked");
            }
            modal({
                name: "organizationCatalogItemForm",
                title: "Создание элемента справочника",
                data: { catalogId: this.props.match.params.id },
                dictionary: this.props.items.find((item) => item.id === Number(this.props.match.params.id)),
                mergeParams,
            });
        };
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Добавить элемент справочника
            </a>
        );
    };

    renderBody = () => {
        const { items, ...props } = this.props;
        return (
            <SharedReactTable
                {...props}
                withoutPagination
                wrapCname="h-100 pb-3"
                items={this.catalogItems()}
                columns={this.state.tableColumns}
            />
        );
    };
}

export default tableContainer(SystemCatalogsShow, "dictionaries");
